<template>
    <div class="hero hero-slider">

        <div v-for="(val, index) in list" :key="index" class="item">
            <div class="item-wrap">
                <div class="wrap">
                    <a class="item-bg" v-lazy:background-image="val.cover" :href="val.url" :target="val.blank == 1 ? '_blank' : '_self'">
                        <img :src="THEME_PATH + 'theme/bkkmenu-2017/assets/img/bound/1500x650.gif'" :alt="val.title" class=" bound hidden-device">
                        <img :src="val.thumbnail" :srcset="val.thumbnailx2+' 2x'" :alt="val.title" class="visible-device">
                    </a>
                    <div class="item-content">
                        <div :class="val.desc != '' ? 'desc-show' : ''" class="meta">
                            <div class="title"><a :href="val.url">{{ val.title }}</a></div>
                            <p class="desc" v-if="val.desc != ''">{{ val.desc }}</p>
                            <div class="category" v-html="val.dptag"></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Vue from 'vue'
import jQuery from 'jquery'
import config from '@/../myconfig.js'

import VueLazyload from 'vue-lazyload'
Vue.use(VueLazyload)

window.jQuery = window.$ = jQuery
const myConfig = config

/* Import Jquery Plugins */
require('@/assets/theme/bkkmenu-2017/assets/js/slick/slick.min.js')
/* Import Jquery Plugins */

export default {
  name: 'HilightHome',
  mounted () {
    this.$nextTick(() => {
      var _slick = jQuery('.hero.hero-slider')
      var items = _slick.find('.item')
      var total = items.length

      _slick.slick({
        dots: true,
        arrows: true,
        infinite: true,
        speed: 800,
        autoplay: true,
        autoplaySpeed: 8000,
        pauseOnFocus: false,
        pauseOnHover: false,
        swipeToSlide: true,
        touchThreshold: 10,
        responsive: [{
          breakpoint: 992,
          settings: {
            arrows: false
          }
        }]
      })
    })
  },
  data: function () {
    return {
      list: window._hilight,
      THEME_PATH: myConfig.THEME_PATH
    }
  }
}
</script>
